import React from 'react'
import { Avatar, Card, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'

export interface CardButtonOption {
  label?: string
  icon?: React.ReactNode
  link?: string
  avatarStyle?: React.CSSProperties
  style?: React.CSSProperties
}

export const CardButton: React.FC<CardButtonOption> = ({
  label,
  icon,
  link,
  avatarStyle,
  style
}) => {
  return (
    <Link to={link || '#'}
      onClick={(e) => {
        e.stopPropagation()
    }}>
      <Card
        hoverable
        style={{
          justifyContent: 'center',
          ...style
        }}
        bodyStyle={{
          padding: 0,
          margin: 4
        }}
        size={'small'}
      >
        <Space size={'small'} align="center">
          <Avatar icon={icon}
            style={{
              backgroundColor: '#2ea8e0',
              padding: 0,
              ...avatarStyle
            }}
            size={'small'}
            shape='circle'/>
          <Typography.Text>{label}</Typography.Text>
        </Space>
      </Card>
    </Link>
  )
}
